import React, { useState, useEffect } from 'react';
import { Button } from '@/components/ui/button';
import { useNavigate } from 'react-router-dom';
import { motion, AnimatePresence } from 'framer-motion';

export const StickyQuoteCTA = () => {
  const navigate = useNavigate();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      // Show after scrolling 300px
      setIsVisible(window.scrollY > 300);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.div
          initial={{ y: 100, opacity: 0 }}
          animate={{ y: 0, opacity: 1 }}
          exit={{ y: 100, opacity: 0 }}
          transition={{ duration: 0.3 }}
          className="fixed bottom-0 left-0 right-0 z-50 p-3 sm:p-4 bg-white border-t border-slate-200 shadow-lg md:hidden"
          data-testid="sticky-quote-cta"
        >
          <Button 
            onClick={() => navigate('/devis')}
            className="w-full bg-[#336DBF] hover:bg-[#2F62AA] text-white font-medium py-5 sm:py-6 text-sm sm:text-base"
            data-testid="sticky-quote-btn"
          >
            Demander un devis gratuit
          </Button>
        </motion.div>
      )}
    </AnimatePresence>
  );
};